import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '@env/environment';
import {NotificationService} from '@notifications';
import {IPermission, IPermissionsRequest} from './interface';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
  ) {
  }

  /**
   * Permission zones granted to the current user. No role restriction — any
   * signed-in user can call this endpoint to refresh their own cached zones.
   */
  getMine(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.API_URL}/permissions/me`);
  }

  get(_: IPermissionsRequest): Observable<IPermission[]> {
    return this.http.get<IPermission[]>(`${environment.API_URL}/permissions`)
    .pipe(
      catchError((error) => {
        this.notificationService.error(error);
        return of([]);
      }),
    );
  }

  updateRoles(code: string, roles: string[]): Observable<IPermission | IPermission[]> {
    return this.http.put<IPermission | IPermission[]>(
      `${environment.API_URL}/permissions/${encodeURIComponent(code)}/roles`,
      {roles},
    );
  }
}
